import { Skeleton } from "@postdaily/ui/components/skeleton";
import { createFileRoute } from "@tanstack/react-router";

import { ApprovalModeCard } from "@/components/approvals/approval-mode-card";
import { ShareLinksCard } from "@/components/approvals/share-links-card";
import { PageHeader } from "@/components/page-header";
import { useCurrentWorkspace } from "@/hooks/use-current-workspace";

export const Route = createFileRoute("/(app)/settings/approvals")({
  component: RouteComponent,
});

function RouteComponent() {
  const { currentWorkspace } = useCurrentWorkspace();

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        size="lg"
        title="Approvals"
        description="Collect client sign-off before posts publish, and manage the review links clients use."
      />
      {currentWorkspace ? (
        <>
          <ApprovalModeCard workspaceId={currentWorkspace.id} />
          <ShareLinksCard workspaceId={currentWorkspace.id} />
        </>
      ) : (
        <Skeleton className="h-72 w-full" />
      )}
    </div>
  );
}
